import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fileConstructionPath" }
const _hoisted_2 = { class: "fileConstructionButtonArea" }
const _hoisted_3 = { class: "fileConstructionInput" }
const _hoisted_4 = { class: "fileConstructionSearch" }

import { useStore } from "vuex";
import { FileConstructionActions, FileConstructionGetters, FileConstructionMutations } from "@/store/modules/fileConstruction";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { Back, DArrowRight, Right, Search, Refresh } from "@element-plus/icons-vue";
import { ElMessage } from 'element-plus'
import { DisplayTypeEnum } from "@/store/modules/fileConstruction/types";



import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "FileConstructionPath"
}
)


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ?
    route.params.projId : route.params.projId[0]);
const targetId = computed(() => typeof (route.params.targetId) === "string" ?
    route.params.targetId : route.params.targetId[0]);
const inputCurrent = ref<string>("");
const searchInput = ref<string>("");
const inputFilePath = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getInputPath}`];
});
const isLoading = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getLoading}`];
});
const displayType = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getIsSearching}`];
});

const currentPath = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getCurrentPath}`];
})
const isBackHistoryAvailable = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getBackHistoryAvailable}`];
});
const isForwardHistoryAvailable = computed(() => {
    return store.getters[`fileConstruction/${FileConstructionGetters.getForwardHistoryAvailable}`];
});
const handleBackward = async () => {
    if (!isLoading.value) {
        let filePath = await store.dispatch(`fileConstruction/${FileConstructionActions.goBack}`);
        if (filePath[filePath.length - 1] !== '/' && filePath !== '') {
            filePath = filePath + '/';
        }
        if (displayType.value === DisplayTypeEnum.FileList) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
                { projId: projectId.value, filePath: filePath, uid: targetId.value },
            );
        } else if (displayType.value === DisplayTypeEnum.Searching) {
            const filename = currentPath.value.split('的搜索结果')[0]
            await store.dispatch(`fileConstruction/${FileConstructionActions.asyncGetSearchResult}`,
                { projId: projectId.value, uid: targetId.value, filename: filename },
            )
        } else if (displayType.value === DisplayTypeEnum.Downloaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetDownloadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else if (displayType.value === DisplayTypeEnum.Uploaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetUploadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else if (displayType.value === DisplayTypeEnum.Extension) {
            const extension = currentPath.value.split('的匹配结果')[0]
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetExtensionFiles}`,
                { projId: projectId.value, uid: targetId.value, extension: extension, isAppend: true },
            );
        }
    }
}

const handleForward = async () => {
    if (!isLoading.value) {
        let filePath = await store.dispatch(`fileConstruction/${FileConstructionActions.goForward}`);
        if (filePath[filePath.length - 1] !== '/' && filePath !== '') {
            filePath = filePath + '/';
        }
        if (displayType.value === DisplayTypeEnum.FileList) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
                { projId: projectId.value, filePath: filePath, uid: targetId.value },
            );
        } else if (displayType.value === DisplayTypeEnum.Searching) {
            const filename = currentPath.value.split('的搜索结果')[0]
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetSearchResult}`,
                { projId: projectId.value, uid: targetId.value, filename: filename },
            );
        } else if (displayType.value === DisplayTypeEnum.Downloaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetDownloadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else if (displayType.value === DisplayTypeEnum.Uploaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetUploadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else if (displayType.value === DisplayTypeEnum.Extension) {
            const extension = currentPath.value.split('的匹配结果')[0]
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetExtensionFiles}`,
                { projId: projectId.value, uid: targetId.value, extension: extension, isAppend: true },
            );
        }
    }
}

const updateInputFilePath = () => {
    if (isLoading.value || inputCurrent.value === currentPath.value) {
        return;
    }
    try {
        let filePath = inputCurrent.value;
        if (filePath[filePath.length - 1] !== '/') {
            filePath = filePath + '/';
        }
        store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
        store.dispatch(
            `fileConstruction/${FileConstructionActions.asyncGetChildrenByPath}`,
            { projId: projectId.value, filePath: filePath, uid: targetId.value },
        );
        store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
    } catch (err) {
        store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
        console.log(err);
    }
}

const searchTargetFile = () => {
    if (isLoading.value) {
        return;
    }
    try {
        if (searchInput.value === '') {
            ElMessage({
                message: '搜索内容不能为空',
                type: 'error',
            })
            return
        }
        let fileName = searchInput.value;
        store.commit(`fileConstruction/${FileConstructionMutations.pushBackHistory}`, currentPath.value);
        store.commit(`fileConstruction/${FileConstructionMutations.setDisplayType}`, 1)
        store.dispatch(
            `fileConstruction/${FileConstructionActions.asyncGetSearchResult}`,
            { projId: projectId.value, uid: targetId.value, filename: fileName },
        )
        store.commit(`fileConstruction/${FileConstructionMutations.cleanForwardHistory}`);
    } catch (err) {
        store.commit(`fileConstruction/${FileConstructionMutations.popBackHistory}`);
        console.log(err);
    }
}

const handleRefresh = async () => {
    if (!isLoading.value) {
        if (displayType.value === DisplayTypeEnum.Downloaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetDownloadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else if (displayType.value === DisplayTypeEnum.Uploaded) {
            await store.dispatch(
                `fileConstruction/${FileConstructionActions.asyncGetUploadedFiles}`,
                { projId: projectId.value, uid: targetId.value, isAppend: false },
            );
        } else {
            return
        }
    }
}

watch(inputFilePath, (newVal) => {
    inputCurrent.value = newVal;
    if (displayType.value === DisplayTypeEnum.FileList && newVal[newVal.length - 1] !== '/') {
        inputCurrent.value = newVal + '/';
    }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "info",
        icon: _unref(Back),
        onClick: handleBackward,
        disabled: !_unref(isBackHistoryAvailable)
      }, null, 8, ["icon", "disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        icon: _unref(Right),
        onClick: handleForward,
        disabled: !_unref(isForwardHistoryAvailable)
      }, null, 8, ["icon", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        modelValue: inputCurrent.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputCurrent).value = $event)),
        placeholder: "我的电脑",
        onKeyup: _withKeys(updateInputFilePath, ["enter"])
      }, null, 8, ["modelValue", "onKeyup"]),
      _createVNode(_component_el_button, {
        icon: _unref(DArrowRight),
        onClick: updateInputFilePath
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_input, {
        modelValue: searchInput.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
        placeholder: "搜索",
        onKeyup: _withKeys(searchTargetFile, ["enter"])
      }, null, 8, ["modelValue", "onKeyup"]),
      _createVNode(_component_el_button, {
        icon: _unref(Search),
        onClick: searchTargetFile
      }, null, 8, ["icon"]),
      (_unref(displayType) === _unref(DisplayTypeEnum).Downloaded || _unref(displayType) === _unref(DisplayTypeEnum).Uploaded)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            icon: _unref(Refresh),
            onClick: handleRefresh
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})